import { createAction, props } from "@ngrx/store";
import { groupingState, GroupState } from "./grouping.reducer";


export const setGroupData = createAction(
  '[Grouping] Set Group Data',
  props<{ data: GroupState[] }>()
);
export const addPannelData = createAction(
  '[Grouping] Add Pannel Data',
  props<{ data: any[], pannelName: string }>()
);
export const setPannelData = createAction(
  '[Grouping] Set Pannel Data',
  props<{ data: any[], pannelName: string }>()
);
export const updateGroupBy = createAction(
  '[Grouping] Update GroupBy',
  props<{ data: groupingState["groupBy"] }>()
);
export const updateGroupByEnabled = createAction(
  '[Grouping] Update GroupByEnabled',
  props<{ data: groupingState["groupByEnabled"] }>()
);
export const updatePannelOpenState = createAction(
  '[Grouping] Update PannelOpenState',
  props<{
    data: boolean,
    groupByColumnData: string,
  }>()
);
export const updatePannelPagination = createAction(
  '[Grouping] Update PannelPagination',
  props<{
    data: { pageSize: number, pageIndex: number },
    groupByColumnData: string,
  }>()
);
export const updateGroupPagination = createAction(
  '[Grouping] Update GroupPagination',
  props<{
    data: number,
  }>()
);
export const updateFilterType = createAction(
  '[Grouping] Update FilterType',
  props<{
    data: string,
  }>()
);
export const updateFilter = createAction(
  '[Grouping] Update Filter',
  props<{
    data: groupingState["filter"],
  }>()
);
export const updateNavHeight = createAction(
  '[Grouping] Update NavHeight',
  props<{
    data: groupingState["navHeight"],
  }>()
);

